import React from 'react';
import { Helmet } from 'react-helmet-async';

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Chính sách bảo mật - QuizTest</title>
        <meta name="description" content="Chính sách bảo mật thông tin người dùng của QuizTest. Cam kết bảo vệ quyền riêng tư và dữ liệu cá nhân." />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-4xl">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl mb-6">
              <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Chính sách bảo mật
            </h1>
            <p className="text-gray-600">
              Cập nhật lần cuối: {new Date().toLocaleDateString('vi-VN')}
            </p>
          </div>

          {/* Content */}
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 space-y-8">
            {/* Introduction */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-blue-600 font-bold">1</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Giới thiệu</h2>
                  <p className="text-gray-600 leading-relaxed">
                    QuizTest cam kết bảo vệ quyền riêng tư và thông tin cá nhân của người dùng. 
                    Chính sách bảo mật này giải thích cách chúng tôi thu thập, sử dụng, lưu trữ và 
                    bảo vệ thông tin của bạn khi sử dụng dịch vụ của chúng tôi.
                  </p>
                </div>
              </div>
            </section>

            {/* Information Collection */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-purple-600 font-bold">2</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Thông tin chúng tôi thu thập</h2>
                  <div className="space-y-4 text-gray-600">
                    <div>
                      <h3 className="font-semibold text-gray-800 mb-2">2.1. Thông tin cá nhân</h3>
                      <ul className="list-disc list-inside space-y-2 ml-4">
                        <li>Họ tên, email, số điện thoại (khi bạn liên hệ với chúng tôi)</li>
                        <li>Kết quả các bài test (IQ, MBTI, EQ, DISC, Holland Codes)</li>
                        <li>Lịch sử làm bài test và thời gian hoàn thành</li>
                      </ul>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-800 mb-2">2.2. Thông tin tự động</h3>
                      <ul className="list-disc list-inside space-y-2 ml-4">
                        <li>Địa chỉ IP, loại trình duyệt, hệ điều hành</li>
                        <li>Thời gian truy cập và các trang đã xem</li>
                        <li>Cookies và công nghệ theo dõi tương tự</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* How We Use Information */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-green-600 font-bold">3</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Cách chúng tôi sử dụng thông tin</h2>
                  <ul className="list-disc list-inside space-y-2 text-gray-600 ml-4">
                    <li>Cung cấp và cải thiện dịch vụ test trực tuyến</li>
                    <li>Phân tích và đánh giá kết quả test của bạn</li>
                    <li>Gửi thông báo về kết quả test và các dịch vụ liên quan</li>
                    <li>Phản hồi các yêu cầu hỗ trợ và câu hỏi của bạn</li>
                    <li>Cải thiện trải nghiệm người dùng và tối ưu hóa website</li>
                    <li>Phân tích thống kê và nghiên cứu (dữ liệu được ẩn danh)</li>
                  </ul>
                </div>
              </div>
            </section>

            {/* Data Protection */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-yellow-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-yellow-600 font-bold">4</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Bảo vệ thông tin</h2>
                  <div className="space-y-3 text-gray-600">
                    <p>Chúng tôi áp dụng các biện pháp bảo mật kỹ thuật và tổ chức để bảo vệ thông tin của bạn:</p>
                    <ul className="list-disc list-inside space-y-2 ml-4">
                      <li>Mã hóa SSL/TLS cho tất cả dữ liệu truyền tải</li>
                      <li>Lưu trữ dữ liệu trên máy chủ bảo mật với tường lửa</li>
                      <li>Kiểm soát truy cập nghiêm ngặt đối với dữ liệu cá nhân</li>
                      <li>Sao lưu dữ liệu định kỳ để phòng ngừa mất mát</li>
                      <li>Cập nhật và vá lỗi bảo mật thường xuyên</li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            {/* Data Sharing */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-red-600 font-bold">5</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Chia sẻ thông tin</h2>
                  <div className="space-y-3 text-gray-600">
                    <p className="font-semibold text-gray-800">Chúng tôi KHÔNG bán hoặc cho thuê thông tin cá nhân của bạn.</p>
                    <p>Thông tin của bạn chỉ được chia sẻ trong các trường hợp sau:</p>
                    <ul className="list-disc list-inside space-y-2 ml-4">
                      <li>Khi có sự đồng ý rõ ràng từ bạn</li>
                      <li>Với các nhà cung cấp dịch vụ hỗ trợ vận hành website (đã ký thỏa thuận bảo mật)</li>
                      <li>Khi được yêu cầu bởi pháp luật hoặc cơ quan có thẩm quyền</li>
                      <li>Để bảo vệ quyền lợi và an toàn của QuizTest và người dùng</li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            {/* Cookies */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-indigo-600 font-bold">6</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Cookies và công nghệ theo dõi</h2>
                  <div className="space-y-3 text-gray-600">
                    <p>Chúng tôi sử dụng cookies và công nghệ tương tự để:</p>
                    <ul className="list-disc list-inside space-y-2 ml-4">
                      <li>Ghi nhớ tùy chọn và cài đặt của bạn</li>
                      <li>Phân tích lưu lượng truy cập và hành vi người dùng</li>
                      <li>Cải thiện hiệu suất và trải nghiệm website</li>
                      <li>Hiển thị nội dung phù hợp với sở thích của bạn</li>
                    </ul>
                    <p className="mt-3">
                      Bạn có thể quản lý cookies thông qua cài đặt trình duyệt. Tuy nhiên, việc vô hiệu hóa 
                      cookies có thể ảnh hưởng đến một số tính năng của website.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* User Rights */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-pink-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-pink-600 font-bold">7</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Quyền của người dùng</h2>
                  <div className="space-y-3 text-gray-600">
                    <p>Bạn có các quyền sau đối với thông tin cá nhân của mình:</p>
                    <ul className="list-disc list-inside space-y-2 ml-4">
                      <li><strong>Quyền truy cập:</strong> Yêu cầu xem thông tin cá nhân chúng tôi lưu trữ</li>
                      <li><strong>Quyền chỉnh sửa:</strong> Yêu cầu cập nhật hoặc sửa đổi thông tin không chính xác</li>
                      <li><strong>Quyền xóa:</strong> Yêu cầu xóa thông tin cá nhân (trong một số trường hợp)</li>
                      <li><strong>Quyền phản đối:</strong> Phản đối việc xử lý thông tin cho mục đích cụ thể</li>
                      <li><strong>Quyền rút lại đồng ý:</strong> Rút lại sự đồng ý đã cấp trước đó</li>
                    </ul>
                    <p className="mt-3">
                      Để thực hiện các quyền này, vui lòng liên hệ với chúng tôi qua email:
                      <a href="mailto:nguyenhuynhduc120597@gmail.com" className="text-blue-600 hover:underline ml-1">
                        nguyenhuynhduc120597@gmail.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Children Privacy */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-orange-600 font-bold">8</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Quyền riêng tư của trẻ em</h2>
                  <p className="text-gray-600 leading-relaxed">
                    Dịch vụ của chúng tôi không nhắm đến trẻ em dưới 13 tuổi. Chúng tôi không cố ý thu thập 
                    thông tin cá nhân từ trẻ em dưới 13 tuổi. Nếu bạn là phụ huynh và phát hiện con bạn đã 
                    cung cấp thông tin cho chúng tôi, vui lòng liên hệ để chúng tôi xóa thông tin đó.
                  </p>
                </div>
              </div>
            </section>

            {/* Policy Changes */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-teal-600 font-bold">9</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Thay đổi chính sách</h2>
                  <p className="text-gray-600 leading-relaxed">
                    Chúng tôi có thể cập nhật Chính sách bảo mật này theo thời gian. Mọi thay đổi sẽ được 
                    đăng tải trên trang này với ngày cập nhật mới. Chúng tôi khuyến khích bạn xem lại 
                    chính sách này định kỳ để nắm bắt thông tin về cách chúng tôi bảo vệ dữ liệu của bạn.
                  </p>
                </div>
              </div>
            </section>

            {/* Contact */}
            <section className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-6 border border-blue-100">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                </div>
                <div>
                  <h2 className="text-xl font-bold text-gray-800 mb-3">Liên hệ với chúng tôi</h2>
                  <p className="text-gray-600 mb-3">
                    Nếu bạn có bất kỳ câu hỏi nào về Chính sách bảo mật này, vui lòng liên hệ:
                  </p>
                  <div className="space-y-2 text-gray-700">
                    <p><strong>Email:</strong> <a href="mailto:nguyenhuynhduc120597@gmail.com" className="text-blue-600 hover:underline">nguyenhuynhduc120597@gmail.com</a></p>
                    <p><strong>Hotline:</strong> <a href="tel:0927663809" className="text-blue-600 hover:underline">0927663809</a></p>
                    <p><strong>Địa chỉ:</strong> 30 Đường Thị Mười, Phường TTH, Quận 12, TPHCM</p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;

